<script>
import VueApexCharts from "vue-apexcharts";
import _ from "lodash";

export default {
  name: "SubdomainChart" ,
  components: {VueApexCharts},
  props: {
    endpoints: {
      type: Array,
      required: true
    }
  },
  computed: {
    subdomain: function () {
      let endpointGroupedByDomain = _.groupBy(this.endpoints, 'subdomain')
      return Object.keys(endpointGroupedByDomain).map(subdomain => {
        return {
          subdomain: subdomain,
          total: endpointGroupedByDomain[subdomain].length,
        }
      })
    },
    chartSeries: function () {
      return this.subdomain.map(subdomain => subdomain.total)
    },
    chartOptions: function () {
      return {
        dataLabels: {
          enabled: false
        },
        chart: {
          width: 900,
          type: 'pie',
        },
        labels: this.subdomain.map(subdomain => subdomain.subdomain.substring(0, 20))
      }
    }
  },
}
</script>

<template>
  <vx-card title="Subdominios">
    <vue-apex-charts
        v-if="chartSeries.length > 0"
        type="pie"
        id="subdomain-chart"
        height="800"
        :options="chartOptions"
        :series="chartSeries"
    />
  </vx-card>
</template>

<style scoped>

</style>